<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <rect class="cls-4" x="9.98" y="33.62" width="21.29" height="30.11" rx="4.45" ry="4.45"/>
  <path class="cls-4" d="m39.51,43.58c0,.08-.06.14-.14.14h-1.26c-.08,0-.14-.06-.14-.14,0-.08.06-.15.14-.15h1.26c.08,0,.14.06.14.15Z"/>
  <path class="cls-4" d="m40.5,39.28l-.48-.48c-.06-.06-.06-.15,0-.21.05-.06.15-.06.2,0l.48.48c.06.06.06.15,0,.21-.03.02-.06.04-.1.04s-.08-.02-.1-.04Z"/>
  <path class="cls-4" d="m40.91,47.66c.06.06.06.15,0,.21l-.48.48s-.06.04-.1.04-.08-.01-.1-.04c-.06-.05-.06-.15,0-.2l.48-.48c.05-.05.15-.05.2,0Z"/>
  <path class="cls-4" d="m44.86,37.94v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14Z"/>
  <path class="cls-4" d="m45.15,49.21v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
  <path class="cls-4" d="m49.77,48.15c.05.05.05.15,0,.2-.03.03-.06.04-.1.04-.04,0-.08-.01-.11-.04l-.48-.48c-.05-.05-.05-.15,0-.21.06-.05.15-.05.21,0l.48.48Z"/>
  <path class="cls-4" d="m49.09,39.28c-.05-.06-.05-.15,0-.21l.48-.48c.06-.06.15-.06.21,0,.05.06.05.15,0,.21l-.48.48s-.06.04-.11.04c-.04,0-.07-.02-.1-.04Z"/>
  <path class="cls-4" d="m49.82,45.8c-.08.16-.23.25-.39.25-.06,0-.12-.01-.18-.04l-4.58-2.12-1.78-4.52c-.09-.22.02-.47.25-.56.22-.09.47.02.56.25l.38.97,1.27,3.22,3.28,1.51,1,.46c.22.1.31.35.21.57Z"/>
  <path class="cls-4" d="m52.04,43.58c0,.08-.06.14-.15.14h-1.25c-.08,0-.15-.06-.15-.14,0-.08.06-.15.15-.15h1.25c.08,0,.15.06.15.15Z"/>
  <path class="cls-4" d="m53.04,23.42h-16.08c-1.44,0-2.61,1.17-2.61,2.61v35.09c0,1.44,1.17,2.61,2.61,2.61h16.08c1.43,0,2.61-1.17,2.61-2.61V26.03c0-1.44-1.17-2.61-2.61-2.61Zm-8.04,27.82c-4.23,0-7.66-3.44-7.66-7.66s3.43-7.67,7.66-7.67,7.66,3.44,7.66,7.67-3.44,7.66-7.66,7.66Z"/>
  <rect class="cls-4" x="58.73" y="13.13" width="21.29" height="50.6" rx="4.45" ry="4.45"/>
  <g>
    <path class="cls-3" d="m72.75,73.22H11.4c-.79,0-1.42-.64-1.42-1.44s.64-1.44,1.42-1.44h61.35c.79,0,1.42.64,1.42,1.44s-.64,1.44-1.42,1.44Z"/>
    <path class="cls-3" d="m72.17,76.77l7.51-4.38c.46-.27.46-.94,0-1.21l-7.51-4.38c-.46-.27-1.03.07-1.03.6v8.76c0,.54.57.87,1.03.6Z"/>
  </g>
  <path class="cls-1" d="m39.51,43.58c0,.08-.06.14-.14.14h-1.26c-.08,0-.14-.06-.14-.14,0-.08.06-.15.14-.15h1.26c.08,0,.14.06.14.15Z"/>
  <path class="cls-1" d="m40.5,39.28l-.48-.48c-.06-.06-.06-.15,0-.21.05-.06.15-.06.2,0l.48.48c.06.06.06.15,0,.21-.03.02-.06.04-.1.04s-.08-.02-.1-.04Z"/>
  <path class="cls-1" d="m40.91,47.66c.06.06.06.15,0,.21l-.48.48s-.06.04-.1.04-.08-.01-.1-.04c-.06-.05-.06-.15,0-.2l.48-.48c.05-.05.15-.05.2,0Z"/>
  <path class="cls-1" d="m44.86,37.94v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14Z"/>
  <path class="cls-1" d="m45.15,49.21v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
  <path class="cls-1" d="m49.77,48.15c.05.05.05.15,0,.2-.03.03-.06.04-.1.04-.04,0-.08-.01-.11-.04l-.48-.48c-.05-.05-.05-.15,0-.21.06-.05.15-.05.21,0l.48.48Z"/>
  <path class="cls-1" d="m49.09,39.28c-.05-.06-.05-.15,0-.21l.48-.48c.06-.06.15-.06.21,0,.05.06.05.15,0,.21l-.48.48s-.06.04-.11.04c-.04,0-.07-.02-.1-.04Z"/>
  <path class="cls-1" d="m49.82,45.8c-.08.16-.23.25-.39.25-.06,0-.12-.01-.18-.04l-4.58-2.12-1.78-4.52c-.09-.22.02-.47.25-.56.22-.09.47.02.56.25l.38.97,1.27,3.22,3.28,1.51,1,.46c.22.1.31.35.21.57Z"/>
  <path class="cls-1" d="m45,35.34c-4.55,0-8.23,3.69-8.23,8.24s3.69,8.23,8.23,8.23,8.23-3.69,8.23-8.23-3.69-8.24-8.23-8.24Zm0,15.9c-4.23,0-7.66-3.44-7.66-7.66s3.43-7.67,7.66-7.67,7.66,3.44,7.66,7.67-3.44,7.66-7.66,7.66Z"/>
  <path class="cls-1" d="m52.04,43.58c0,.08-.06.14-.15.14h-1.25c-.08,0-.15-.06-.15-.14,0-.08.06-.15.15-.15h1.25c.08,0,.15.06.15.15Z"/>
  <path class="cls-2" d="m45,34.76c-4.85,0-8.81,3.96-8.81,8.82s3.96,8.81,8.81,8.81,8.81-3.96,8.81-8.81-3.95-8.82-8.81-8.82Zm0,16.47c-4.23,0-7.66-3.44-7.66-7.66s3.43-7.67,7.66-7.67,7.66,3.44,7.66,7.67-3.44,7.66-7.66,7.66Z"/>
  <g>
    <path class="cls-3" d="m45.15,36.68v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
    <g>
      <line class="cls-3" x1="40.13" y1="38.7" x2="40.6" y2="39.18"/>
      <path class="cls-3" d="m40.7,39.28s-.06.04-.1.04-.08-.02-.1-.04l-.48-.48c-.06-.06-.06-.15,0-.21.05-.06.15-.06.2,0l.48.48c.06.06.06.15,0,.21Z"/>
    </g>
    <g>
      <line class="cls-3" x1="40.33" y1="48.24" x2="40.81" y2="47.77"/>
      <path class="cls-3" d="m40.91,47.87l-.48.48s-.06.04-.1.04-.08-.01-.1-.04c-.06-.05-.06-.15,0-.2l.48-.48c.05-.05.15-.05.2,0,.06.06.06.15,0,.21Z"/>
    </g>
    <g>
      <line class="cls-3" x1="49.67" y1="48.24" x2="49.19" y2="47.77"/>
      <path class="cls-3" d="m49.77,48.34s-.06.04-.1.04c-.04,0-.08-.01-.11-.04l-.48-.48c-.05-.05-.05-.15,0-.21.06-.05.15-.05.21,0l.48.48c.05.05.05.15,0,.2Z"/>
    </g>
    <g>
      <line class="cls-3" x1="49.67" y1="38.7" x2="49.19" y2="39.18"/>
      <path class="cls-3" d="m49.77,38.81l-.48.48s-.06.04-.11.04c-.04,0-.07-.02-.1-.04-.05-.06-.05-.15,0-.21l.48-.48c.06-.06.15-.06.21,0,.05.06.05.15,0,.21Z"/>
    </g>
    <g>
      <line class="cls-3" x1="38.11" y1="43.58" x2="39.36" y2="43.58"/>
      <path class="cls-3" d="m39.51,43.58c0,.08-.06.14-.14.14h-1.26c-.08,0-.14-.06-.14-.14,0-.08.06-.15.14-.15h1.26c.08,0,.14.06.14.15Z"/>
    </g>
    <g>
      <line class="cls-3" x1="45" y1="50.47" x2="45" y2="49.21"/>
      <path class="cls-3" d="m45.15,49.21v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
    </g>
    <g>
      <line class="cls-3" x1="51.89" y1="43.58" x2="50.64" y2="43.58"/>
      <path class="cls-3" d="m52.04,43.58c0,.08-.06.14-.15.14h-1.25c-.08,0-.15-.06-.15-.14,0-.08.06-.15.15-.15h1.25c.08,0,.15.06.15.15Z"/>
    </g>
  </g>
  <g>
    <polygon class="cls-2" points="49.43 45.62 45 43.58 43.28 39.22 44.07 40.03 45.34 43.26 48.61 44.77 49.43 45.62"/>
    <path class="cls-2" d="m49.82,45.8c-.08.16-.23.25-.39.25-.06,0-.12-.01-.18-.04l-4.58-2.12-1.78-4.52c-.09-.22.02-.47.25-.56.22-.09.47.02.56.25l.38.97,1.27,3.22,3.28,1.51,1,.46c.22.1.31.35.21.57Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "TimeVolumeTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #a3d7be;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: #cfeae0;
  }
</style>